/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPanoramaVerticalFilled = createReactComponent("filled", "panorama-vertical-filled", "IconPanoramaVerticalFilled", [["path", { "d": "M17.53 2c1.39 0 2.364 1.389 1.87 2.692l-.013 .026l-.156 .431c-1.623 4.572 -1.622 9.123 .003 13.703l.168 .458a2 2 0 0 1 -1.873 2.69h-11c-1.386 0 -2.394 -1.386 -1.897 -2.694c1.845 -4.879 1.845 -9.734 0 -14.612c-.495 -1.304 .48 -2.694 1.87 -2.694z", "key": "svg-0" }]]);

export { IconPanoramaVerticalFilled as default };
//# sourceMappingURL=IconPanoramaVerticalFilled.mjs.map
